module.exports = angular.module('eatself').component('socialSharing',{
	bindings: {
		item: '<',
	},
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
		inject: ['ShopService'],
		methods: {
			$onInit() {
				this.text = this.ShopService.shop.DefaultName + ' - ' + this.item.product.dn
				this.url = document.location.href;
			},
		}
	}),
	template: `
	<style>
		.social li a {
			margin: 15px;
		}
		.social {
			min-height: 80px;
		}
	</style>
	
	<div class="social"  >
		<ul class="row"  >
			<li class="col-md-4 col-md-6 tw">
				<a style="margin: 0px;" href title="twitter" socialshare socialshare-provider="twitter"
					socialshare-text="{{vm.text}}">
					<i class="fa fa-twitter"></i>
					<span>partager</span>
				</a>
			</li>
			<li class="col-md-4 col-md-6 fb">
				<a style="margin: 0px;" href socialshare socialshare-provider="facebook" socialshare-type="share"
					socialshare-url="{{vm.url}}"
					socialshare-title="{{vm.text}}" socialshare-via="341309169563661">
					<i class="fa fa-facebook"></i>
					<span>partager</span>
				</a>
			</li>
		</ul>
	</div>
	`,
})
